module.exports = __webpack_public_path__ + "static/media/elmgray.1f46e91e.png";